"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.history = void 0;
var enhanceWithRouter_1 = require("./enhanceWithRouter");
var appLifeCycles_1 = require("./appLifeCycles");
var pageLifeCycles_1 = require("./pageLifeCycles");
var emitLifeCycles_1 = require("./emitLifeCycles");
var createBaseApp_1 = require("./createBaseApp");
var history_1 = require("./history");
Object.defineProperty(exports, "history", { enumerable: true, get: function () { return history_1.history; } });
var utils_1 = require("./utils");
var nativeEventListener_1 = require("./nativeEventListener");
var getSearchParams_1 = require("./getSearchParams");
var collectAppLifeCycle_1 = require("./collectAppLifeCycle");
function createShareAPI(_a, loadRuntimeModules) {
    var withRouter = _a.withRouter, createElement = _a.createElement, useEffect = _a.useEffect, _b = _a.initHistory, initHistory = _b === void 0 ? true : _b;
    var _c = pageLifeCycles_1.createUsePageLifeCycle({ useEffect: useEffect }), usePageShow = _c.usePageShow, usePageHide = _c.usePageHide;
    return {
        createBaseApp: createBaseApp_1.default({ loadRuntimeModules: loadRuntimeModules, createElement: createElement, initHistory: initHistory }),
        // history api
        withRouter: enhanceWithRouter_1.default({ withRouter: withRouter, createElement: createElement }),
        createHistory: history_1.createHistory,
        getHistory: history_1.getHistory,
        getSearchParams: getSearchParams_1.default,
        // lifeCycle api
        emitLifeCycles: emitLifeCycles_1.default,
        collectAppLifeCycle: collectAppLifeCycle_1.default,
        usePageShow: usePageShow,
        usePageHide: usePageHide,
        withPageLifeCycle: pageLifeCycles_1.withPageLifeCycle,
        addAppLifeCycle: appLifeCycles_1.addAppLifeCycle,
        // utils api
        pathRedirect: utils_1.pathRedirect,
        registerNativeEventListeners: nativeEventListener_1.registerNativeEventListeners,
        addNativeEventListener: nativeEventListener_1.addNativeEventListener,
        removeNativeEventListener: nativeEventListener_1.removeNativeEventListener
    };
}
exports.default = createShareAPI;
